/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  window.customClosePswp = () => {
    const closeBtn = document.querySelector('.pswp__custom-close');
    if (closeBtn) closeBtn.click();
  }
  
  window.openShopifyCustomerCookiePrefs = () => {
	if(window.privacyBanner != undefined){
		window.privacyBanner.showPreferences();
	}
  }

	window.getCookieByName = (name) => (
		document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
	)

  const handleMarketChange = (event) => {
		event.preventDefault();
		const selectedOption = event.currentTarget;

		const form = selectedOption.closest(".form--localization");
		const popoutSelect = form.querySelector(".popout--country");

		// Get form inputs
		const input = popoutSelect.querySelector("[data-popout-input]");
		const redirectInput = popoutSelect.querySelector("[data-popout-redirect]");
		const attrValue = selectedOption.hasAttribute("data-value") ? selectedOption.getAttribute("data-value") : "";
		input.value = attrValue;

		// Avoid displaying the preview bar in production
		const previewtheme = window.Shopify.theme.role === "unpublished" ? `&preview_theme_id=${Shopify.theme.id}`: ''; 
		// Specify the theme preview
		redirectInput.value = `${redirectInput.value}${previewtheme}`;

		// Change market and domain
		form.submit();
	};

	// Function to perform a market redirection when the current market is not enabled
	function redirectMarketIfRequired() {
		// select a market to redirect to from the market selector
		const marketRedirectRequired = document.querySelector("#popout-list__option--market-redirect");
		if(marketRedirectRequired) {
			marketRedirectRequired.addEventListener("click", handleMarketChange);
			marketRedirectRequired.click();
		}
	}
	redirectMarketIfRequired();


	/* Save user way widget original position on init */
	document.addEventListener('userway:init_completed', function (event) {
		const userwayPosition = window.UserWayWidgetApp?.ContextHolder?.config?.tunings?.widget_position;
		if(userwayPosition){
			window.UserWayOriginalPosition = userwayPosition;
		}
  	})

	/* Move user way widget position on render if necessary */
	document.addEventListener('userway:render_completed', function (event) {
	if(window.UserWay != undefined && window.customDrawerIsOpen){
          window.UserWay.setPosition(3)
      }
	})
	/* Move user way widget position on drawer open */
	document.addEventListener("theme:drawer:open", ()=> {
		window.customDrawerIsOpen = true;
        if(window.UserWay != undefined){
            window.UserWay.setPosition(3)
        }
	});

	/* Move user way widget position on drawer close */
	document.addEventListener("theme:drawer:close", ()=> {
		window.customDrawerIsOpen = false;
        if(window.UserWay != undefined){
          let position = 5;
          if(window.UserWayOriginalPosition != null){
            position = parseInt(Window.UserWayOriginalPosition);
          }
          window.UserWay.setPosition(position);
        }
	});

	window.loadScriptAfterInteraction = (scriptUrl, attributes = {})  =>{
		function loadScript() {
			var script = document.createElement('script');
			script.src = scriptUrl;
			script.defer = true;
			script.async = true;
			for (var key in attributes) {
				if (attributes.hasOwnProperty(key)) {
					script.setAttribute(key, attributes[key]);
				}
			}
			document.body.appendChild(script);
		}
	
		document.addEventListener('click', loadScript, { once: true });
		document.addEventListener('scroll', loadScript, { once: true });
	}

	// open in a new tab all external links on the site, excluding Shopify links and internal links
	document.addEventListener('DOMContentLoaded', function() {
		const allLinks = document.querySelectorAll('a');
		allLinks.forEach(link => {
			const linkHref = link.href;
			const isShopify = linkHref.includes('shopify.com');
			const isInternal = linkHref.startsWith(window.location.origin);
	
			if (!isShopify && !isInternal && !link.classList.contains('popout-list__option')) {
				link.setAttribute('target', '_blank');
			}
		});
	});
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
